import { Avatar, Button, ConfigProvider, Flex, Form, Input, Layout, Menu, Modal, Space, Watermark } from "antd";
import { Content, Footer, Header } from "antd/es/layout/layout";
import Sider from "antd/es/layout/Sider";
import { LaptopOutlined, NotificationOutlined, UserOutlined, MenuUnfoldOutlined, MenuFoldOutlined, DollarOutlined, HomeOutlined, LogoutOutlined, DeploymentUnitOutlined, ShareAltOutlined, InfoCircleOutlined, RocketOutlined, ProfileOutlined, SafetyOutlined, AntDesignOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from "react";
import './WorkSpaceLayOut.css'
import Story from "../../Components/Story/Story";
import Morakasi from "../../Components/Morakasi/Morakasi";
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import AddStory from "../../Components/AddStory/AddStory";
import Salary from "../../Components/Salary/Salary";
import SupervisorScore from "../../Components/SupervisorScore/SupervisorScore";
import Home from "../../Components/Home/Home";
import Cookies from "universal-cookie";
import LoginPage from "../../Pages/Login/LoginPage";
import Missions from "../../Components/Missions/Missions";
import InOut from "../../Components/InOut/InOut";
import ConfirmMorakhasi from "../../Components/ConfirmMorakhasi/ConfirmMorakhasi";
import { createStyles } from "antd-style";
import FormItem from "antd/es/form/FormItem";
import { PersonelComment } from "../../Model/dbo/Comment";
import Title from "antd/es/typography/Title";
import { AddComment } from "../../RestAPI/dbo/Morakasiapi";
import Survey from "../../Components/Survey/Survey";
import Dashboard from "../../Components/BiDashboard/Layout/Dashboard";



function WorkSpaceLayOut() {


    const [form] = Form.useForm();

 async   function onFinish (values: PersonelComment)  {

    if(values.Name==null)
        values.Name="";
       await AddComment(values)

       alert("نظر شما ثبت شد")
       setIsOpenCommentModal(false);
       form.resetFields();
    }

    const user = new Cookies().get('user');
    var isManager = false;
    if (user.PersonelNo == 318)
        isManager = true;
    else
        isManager = user.IsManager;

    const navigate = useNavigate();
    const [items, setItems] = useState<Array<any>>([
        {
            key: '1',
            label: 'صفحه اصلی',
            icon: React.createElement(HomeOutlined),
            onClick: () => { navigateToSelectItem("/home"); }
        },
        {
            key: '2',
            label: 'فیش های حقوقی',
            icon: React.createElement(DollarOutlined),
            onClick: () => { navigateToSelectItem("/Salary"); }
        },
        {
            key: '3',
            label: 'لیست مرخصی',
            icon: React.createElement(NotificationOutlined),
            onClick: () => { navigateToSelectItem("/Morakasi"); }

        },
        {
            key: '4',
            label: 'تایید مرخصی',
            icon: React.createElement(SafetyOutlined),
            onClick: () => { navigateToSelectItem("/ConfirmMorakhasi"); }

        },
        {
            key: '5',
            label: 'لیست ماموریت ها',
            icon: React.createElement(RocketOutlined),
            onClick: () => { navigateToSelectItem("/Missions"); }
        },

        {
            key: '6',
            label: 'سوابق حضور',
            icon: React.createElement(ProfileOutlined),
            onClick: () => { navigateToSelectItem("/InOut"); }
        },
        false && {
            key: '7',
            label: 'درخواست جلسه',
            icon: React.createElement(DeploymentUnitOutlined),
            onClick: () => { }
        },
        false && {
            key: '8',
            label: 'ثبت تجربیات',
            icon: React.createElement(ShareAltOutlined),
            stylis: "",
            onClick: () => { }
        },
        isManager && {
            key: '9',
            label: 'ثبت اطلاعیه',
            icon: React.createElement(InfoCircleOutlined),
            onClick: () => { navigateToSelectItem("/AddStory"); }
        },

        {
            key: '10',
            label: 'نظر سنجی(6ماهه)',
            icon: React.createElement(ProfileOutlined),
            onClick: () => { navigateToSelectItem("/Survey"); }
        },
        {
            key: '11',
            label: (<Button color="primary" variant="solid">
                پیشنهاد / انتقاد
            </Button>),
            onClick: () => { setIsOpenCommentModal(true) }
        },
        {
            key: '12',
            label: (<Button color="default" variant="outlined">خروج از پنل کاربری</Button>),
            onClick: logout
        },

        ,
        {
            key: '13',
            label: (<Button color="cyan" variant="solid">BI Dashboard</Button>),
            onClick: () => { navigateToSelectItem("/Dashboard"); }
        },
    ]);

    function navigateToSelectItem(item: string) {
        focusLayout(true);
        navigate(item);
    }

    async function logout() {
        var cook = new Cookies();
        await cook.remove('user')
        if (!cook.get('user')) {
            window.location.reload();
        }
    }

    const [collapsed, setCollapsed] = useState(true);
    const [menuSize, setMenuSize] = useState(0)
    const [fadeLayout, setFadeLayout] = useState(false);
    const [isOpenCommentModal, setIsOpenCommentModal] = useState(false);

    useEffect(() => {

        configMenu();
    }, []);
    function configMenu() {
        const screen = ((window.innerWidth < 700) ? 'sm' : 'lg');
        if (screen == 'sm') {
            setCollapsed(false);
            setFadeLayout(false);
            setMenuSize(0);
        }
        else {
            setCollapsed(true);
            setFadeLayout(true);
            setMenuSize(180);
        }
    }

    const toggleCollapsed = () => {
        if (collapsed) {
            setMenuSize(0);
            setFadeLayout(false);
        } else {
            setMenuSize(180)
            setFadeLayout(true);
        }
        setCollapsed(!collapsed);
    };
    function focusLayout(isMenuClicker: boolean) {
        if (menuSize != 0) {
            setMenuSize(0);
            setFadeLayout(false);
            setCollapsed(!collapsed);
        }
        if (isMenuClicker === true) {
            setMenuSize(0);
            setFadeLayout(false);
            setCollapsed(!collapsed);
        }

    }

    return (
        <>
            <Flex >

                <Sider width={menuSize} style={{
                    textAlign: 'right',
                    color: '#fff',
                    backgroundColor: '#001529',
                    position: "absolute",
                    zIndex: 1
                }}>
                    <div style={{ width: menuSize, height: '100%' }}>
                        <Button size="large" type="primary" onClick={toggleCollapsed}
                            style={{ marginBottom: 20, backgroundColor: '#f29900', marginTop: 30, marginRight: 5 }}>
                            {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                        </Button>
                        <Menu
                            mode="vertical"
                            theme="dark"
                            items={items}
                            style={{ height: "94vh" }}
                        />
                    </div>
                </Sider>
            </Flex>
            <Flex onClick={() => { focusLayout(false) }} style={{ minHeight: '100%', opacity: fadeLayout ? 0.2 : 1 }} gap="middle" wrap>

                <Layout style={{
                    overflow: 'hidden',
                    minHeight: '100%'
                }}>
                    <Header style={{
                        textAlign: 'center',
                        color: '#fff',
                        height: '100px',
                        padding: '0',
                        backgroundColor: '#fff',
                        zIndex: 0,
                    }}>
                        <div
                            style={{ backgroundColor: 'white', height: 95, zIndex: 9999, right: 0, position: "absolute" }}>

                            <Button size="large" type="primary" onClick={toggleCollapsed}
                                style={{ backgroundColor: '#f29900', marginTop: 30, marginRight: 5 }}  >
                                {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                            </Button>
                        </div>
                        <Story />
                    </Header>
                    <Layout>




                        <Content style={{
                            color: 'red',
                            backgroundColor: '#dddddc',
                            minHeight: '100%'
                        }}>
                            <div>

                                <Routes>
                                    <Route path="*" element={<Navigate to='/Home' />} />
                                    <Route path='/Home' element={<Home />} />
                                    <Route path='/Morakasi' element={<Morakasi />} />
                                    <Route path='/AddStory' element={<AddStory />} />
                                    <Route path='/Salary' element={<Salary />} />
                                    <Route path='/Score' element={<SupervisorScore />} />
                                    <Route path='/Missions' element={<Missions />} />
                                    <Route path='/InOut' element={<InOut />} />
                                    <Route path='/ConfirmMorakhasi' element={<ConfirmMorakhasi />} />
                                    <Route path='/Survey' element={<Survey />} />
                                    <Route path='/Dashboard' element={<Dashboard />} />
                                </Routes>
                            </div>

                        </Content>
                    </Layout>
                    <Footer style={{
                        textAlign: 'center',
                        color: '#fff',
                        backgroundColor: '#f29900',
                        fontSize: '10px',
                        height: '25px',
                    }}>
                        made with ♥ in EP
                    </Footer>
                </Layout>
            </Flex >


            <Modal title="ثبت انتقادات و پیشنهادات"
                footer={null}
                cancelText={"انصراف"}
                okText={"ثبت"}
                open={isOpenCommentModal}
                onCancel={() => { setIsOpenCommentModal(false) }}

            >

                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    form={form}
                    name="dynamic_form_complex"
                    style={{ maxWidth: 600 }}
                    onFinish={onFinish}
                >
                    <Form.Item name="Name" label="نام " 
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        name="Title"
                        label="عنوان"
                        rules={[{ required: true, message: "عنوان را وارد کنید" }]}>
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="Description"
                        label="متن"
                        rules={[{ required: true, message: "لطفاً متن را وارد کنید!" }]}
                    >
                        <Input.TextArea rows={4} placeholder="متن خود را وارد کنید" />
                    </Form.Item>
                    <Form.Item>
                        <Space>
                            <Button type="primary" htmlType="submit" >
                                ثبت
                            </Button>
                            <Button type="default" onClick={() => { setIsOpenCommentModal(false) }}>
                                انصراف
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>

                <Title level={3} style={{color:"red"}} >توجه:  پر کردن نام اجباری نیست</Title>

            </Modal>

        </>
    );
}

export default WorkSpaceLayOut;
